export enum NavStepState {
  Enabled = 1,
  Disabled,
  Complete,
  InProgress,
  Error
}
